import { useQuery, useMutation, useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'
import { clientsAPI, formatApiError } from '../utils/api'

export const useClients = (params = {}) => {
  return useQuery(
    ['clients', params],
    () => clientsAPI.getAll({ params }).then(res => res.data),
    {
      keepPreviousData: true,
      staleTime: 30 * 1000, // 30 seconds
      refetchOnWindowFocus: true, // Refetch when window gains focus
      refetchOnMount: true, // Always refetch on mount
    }
  )
}

export const useClient = (id) => {
  return useQuery(
    ['client', id],
    () => clientsAPI.getById(id).then(res => res.data),
    {
      enabled: !!id,
      refetchOnWindowFocus: true, // Refetch when window gains focus
      refetchOnMount: true, // Always refetch on mount
    }
  )
}

export const useCreateClient = () => {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(
    (clientData) => clientsAPI.create(clientData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('clients')
        enqueueSnackbar('Cliente creado exitosamente', { variant: 'success' })
      },
      onError: (error) => {
        const message = formatApiError(error)
        enqueueSnackbar(message, { variant: 'error' })
      }
    }
  )
}

export const useUpdateClient = () => {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(
    ({ id, ...clientData }) => clientsAPI.update(id, clientData),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries('clients')
        queryClient.invalidateQueries(['client', variables.id])
        enqueueSnackbar('Cliente actualizado exitosamente', { variant: 'success' })
      },
      onError: (error) => {
        const message = formatApiError(error)
        enqueueSnackbar(message, { variant: 'error' })
      }
    }
  )
}

export const useDeleteClient = () => {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(
    (id) => clientsAPI.delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('clients')
        enqueueSnackbar('Cliente eliminado exitosamente', { variant: 'success' })
      },
      onError: (error) => {
        const message = formatApiError(error)
        enqueueSnackbar(message, { variant: 'error' })
      }
    }
  )
}
